// extracted by mini-css-extract-plugin
export var appContainer = "OldMobileBanner_appContainer__ygkUP";
export var container = "OldMobileBanner_container__WAbPj";
export var dbClose = "OldMobileBanner_dbClose__ROeqn";
export var dbCloseIcon = "OldMobileBanner_dbCloseIcon__jKV0n";
export var description = "OldMobileBanner_description__Q-HFf";
export var details = "OldMobileBanner_details__SvTdc";
export var logoImage = "OldMobileBanner_logoImage__bcl3Z";
export var openButton = "OldMobileBanner_openButton__Z4KGw";
export var title = "OldMobileBanner_title__l7PwO";